import { getMessages } from '../../../../../../store/constants';

export const INFO_TITLE =  getMessages().getText('board_settings.info.title');
